import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";
import { formatDotDate } from "@/utils/format";

interface NewsCardProps {
  item: NewsItem;
  variant?: "default" | "compact" | "row";
}

export default function NewsCard({ item, variant = "default" }: NewsCardProps) {
  if (variant === "compact") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex gap-4 border-b border-background-200 py-4 last:border-b-0"
      >
        <div className="h-20 w-28 shrink-0 overflow-hidden rounded-lg bg-background-200 md:h-24 md:w-36">
          <img
            src={item.cover}
            alt={`${item.title} - 张柏芝新闻配图`}
            title={`${item.title} - 张柏芝新闻`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col justify-between py-0.5">
          <h3 className="line-clamp-2 text-sm font-medium leading-6 text-foreground-900 transition-colors group-hover:text-primary-700">
            {item.title}
          </h3>
          <div className="flex items-center gap-3 text-[11px] text-foreground-500">
            <span className="rounded-sm bg-secondary-200/70 px-1.5 py-0.5 text-secondary-900">
              {item.category}
            </span>
            <span>{formatDotDate(item.publishedAt)}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="h-44 w-full overflow-hidden bg-background-200 md:h-48">
        <img
          src={item.cover}
          alt={`${item.title} - 张柏芝新闻配图`}
          title={`${item.title} - 张柏芝新闻`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col gap-3 p-4 md:p-5">
        <div className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-500">
          <span className="rounded-sm bg-primary-100 px-2 py-0.5 text-primary-800">{item.category}</span>
          <span>{formatDotDate(item.publishedAt)}</span>
          <span className="text-foreground-300">·</span>
          <span>{item.source}</span>
        </div>
        <h3 className="line-clamp-2 font-heading text-base font-semibold leading-7 text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="line-clamp-2 text-[13px] leading-6 text-foreground-600">{item.summary}</p>
        <div className="mt-auto flex items-center justify-between pt-1 text-[11px] text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-accent-500" aria-hidden="true"></i>
            热度 {item.heat}
          </span>
          <span className="flex items-center gap-1 text-primary-700">
            阅读全文
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}